/* eslint-disable */
<template>
  <v-container id="home-container">
    <v-card class="pa-3">
      <v-card-title>Over si COVID GreenPass</v-card-title>
      <v-divider />
      <v-card-text id="qr-code-scanner-container">
        <form
          action="https://www.paypal.com/donate"
          method="post"
          target="_new"
        >
          <div
            v-if="!camera.enable&&!isFacebookApp"
            id="qr-code-scanner-button"
          >
            <v-btn
              x-large
              color="primary"
              class="my-5"
              @click="camera.enable=true"
            >
              Skenuj QR na COVID PASE
            </v-btn>
            <input
              type="hidden"
              name="hosted_button_id"
              value="D35XWPY8QBETE"
            >
            <v-btn
              x-large
              color="success"
              class="my-5"
              type="submit"
            >
              Podpor ma cez PayPal
            </v-btn>
          <!--
          <qrcode-capture-button
            class="my-5"
            @decode="onDecode"
            @error:decode="reportError"
            @error:detect="reportError"
          />
          -->
          </div>
        </form>
        <div v-if="enableContainedCamera&&!isFacebookApp">
          <qrcode-stream @decode="onDecode" />
        </div>
        <div
          v-if="enableFullScreenCamera&&!isFacebookApp"
          style="position: absolute; top: 0; left: 0"
        >
          <qrcode-stream
            style="width: 100vw; height: 100vh"
            @decode="onDecode"
          />
        </div>
        <div v-if="isFacebookApp">
          <h3>Otvárate túto stránku vo Facebook integrovanom prehliadači?</h3>
          <br>
          <hr>
          <br>
          <p>
            Súčasťou Facebook aplikácie je aj mikroprehliadač stránok. Tento však neumožňuje prístup ku kamere mobilného zariadenia a preto Vám nemôže fungovať kamera pre skenovanie QR Kódu.
            Otvorte si našu stránku v bežnom mobilnom prehliadači (Safari, Chrome, ....), alebo kliknite v pravo hore na [...] a zvoľte "Otvoriť v prehliadači".
          </p>
          <p>
            <br><br>
            <b>Ďakujeme za pochopenie!</b>
          </p>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
// import QrcodeCaptureButton from '../components/QrcodeUploadButton'

export default {
  name: 'Home',
  components: {
    // QrcodeCaptureButton,
    QrcodeStream
  },
  data: () => ({
    camera: {
      fullscreen: false,
      stream: false,
      capture: false,
      enable: false
    }
  }),
  computed: {
    enableFullScreenCamera () {
      return this.camera.enable && this.camera.fullscreen
    },
    enableContainedCamera () {
      return this.camera.enable && !this.camera.fullscreen
    },
    isFacebookApp () {
      var ua = navigator.userAgent || navigator.vendor || window.opera
      return (ua.indexOf('FBAN') > -1) || (ua.indexOf('FBAV') > -1)
    }
  },
  methods: {
    onDecode (e) {
      this.$router.push({
        name: 'Results',
        params: { qr: e }
      })
    },
    reportError (msg) {
      msg = msg ?? 'Nepodarilo sa rozoznať QR Kód'
      alert(`Pri analýze QR Kódu sa vyskytla chyba \n${msg}`)
    }
  }
}
</script>

<style scoped lang="scss">
@import '~vuetify/src/styles/settings/_variables';

#home-container{
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}

#qr-code-scanner-button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-image: url("../assets/example-qr.png");
  background-size: contain;
  background-position: center;

  padding: 40px 0;
}

#qr-code-scanner-button > * {
  width: 250px;
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  #home-container {
    padding: 0 !important;
    height: 100%;

    > .v-card {
      display: flex;
      flex-direction: column;
    }
  }
  #home-container > div {
    height: 100%;
  }

  #qr-code-scanner-container {
    display: flex;
    flex-grow: 1;
    justify-content: center;
    align-content: center;
  }
}

</style>
